module.exports = __webpack_public_path__ + "static/media/allRewards.40be8ff1.png";